import '@lsoft/tailwind-config/global.css';
import CustomApp from '../src/app/ShopApp';

export default CustomApp;
